export const formatPlanLabel = (plan) => String(plan || '-').toUpperCase();

export const filterTenants = (items = [], { search = '', plan = '', status = '' } = {}) => {
  const searchNorm = String(search || '').toLowerCase();
  return items.filter((item) => {
    if (plan && String(item?.plan || '') !== plan) return false;
    if (status && String(item?.status || '') !== status) return false;
    if (searchNorm) {
      const haystack = `${item?.tenantName || ''} ${item?.tenantId || ''}`.toLowerCase();
      if (!haystack.includes(searchNorm)) return false;
    }
    return true;
  });
};
